import React from 'react'
import * as E from './bannerMainImageSectionElements'

const BannerMainImageSection = (props) => {
  return (
    <E.ParentDiv fluid id={props.id + '.image'}>
      {global.config.isBrandMX && (
        <E.MaxxiaBannerImage imageName={props.imageName} height={500} />
      )}
      {global.config.isBrandRS && (
        <E.RemServBannerImage
          imageName={
            props.isProposal ? 'BannerProposalRemServ' : 'BannerImageRemServ2'
          }
          height={500}
        />
      )}
      <E.ChildPropsDiv>
        <E.BannerContentDiv
          id={props.id + '.contentwithsrc'}
          isLeftAlign={props.isLeftAlign}
          isHomePage={props.isHomePage}
        >
          {props.children}
        </E.BannerContentDiv>
      </E.ChildPropsDiv>
    </E.ParentDiv>
  )
}

export default BannerMainImageSection
